import React from 'react';
import ProfileElement from './profileTab';
import { ProfileTabs } from '../../utils/const';
import Nav from 'react-bootstrap/Nav';

const ProfileTabLinks = () => {
	return (
		<div>
			<Nav
				className=" mobile_tabs profile-tabs"
				defaultActiveKey={window.location.pathname}
			>
				{Object.keys(ProfileTabs).map((detail, index) => (
					<ProfileElement key={index} {...ProfileTabs[detail]} />
				))}
			</Nav>
		</div>
	);
};

export default ProfileTabLinks;
